<p>
  sem-text-input works!
</p>
